// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".btn-link[data-v-228b0f5e] {\n  color: #7d8bf7;\n}\n.bg[data-v-228b0f5e] {\n  background: var(--rejection-reason-background);\n}", ""]);
// Exports
module.exports = exports;
